import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { ChevronDown } from 'lucide-react';
import theme from '../../../styles/theme';

const faqs = ['q1', 'q2', 'q3', 'q4', 'q5'];

const FAQSection = () => {
  const { t } = useTranslation();
  const [open, setOpen] = useState(null);

  const toggle = (i) => setOpen((prev) => (prev === i ? null : i));

  const s = {
    section: {
      padding: `${theme.spacing['3xl']} ${theme.spacing.xl}`,
      backgroundColor: theme.colors.background.paper,
    },
    inner: {
      maxWidth: '740px',
      margin: '0 auto',
    },
    header: {
      textAlign: 'center',
      marginBottom: theme.spacing['3xl'],
    },
    eyebrow: {
      display: 'inline-block',
      fontSize: theme.typography.fontSize.sm,
      fontWeight: theme.typography.fontWeight.semibold,
      letterSpacing: '0.1em',
      textTransform: 'uppercase',
      color: theme.colors.secondary.dark,
      marginBottom: theme.spacing.md,
    },
    h2: {
      fontSize: theme.typography.fluid.h2,
      fontWeight: theme.typography.fontWeight.bold,
      fontFamily: theme.typography.fontFamily.heading,
      color: theme.colors.text.primary,
    },
    item: {
      borderBottom: `1px solid ${theme.colors.border.light}`,
    },
    question: (isOpen) => ({
      width: '100%',
      background: 'none',
      border: 'none',
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      padding: `${theme.spacing.lg} 0`,
      cursor: 'pointer',
      fontSize: theme.typography.fontSize.base,
      fontWeight: theme.typography.fontWeight.semibold,
      color: isOpen ? theme.colors.primary.main : theme.colors.text.primary,
      textAlign: 'left',
      gap: theme.spacing.md,
    }),
    chevron: (isOpen) => ({
      flexShrink: 0,
      transform: isOpen ? 'rotate(180deg)' : 'rotate(0deg)',
      transition: `transform ${theme.transitions.fast}`,
      color: theme.colors.text.secondary,
    }),
    answer: (isOpen) => ({
      maxHeight: isOpen ? '300px' : '0',
      overflow: 'hidden',
      transition: `max-height ${theme.transitions.normal} ease`,
    }),
    answerInner: {
      paddingBottom: theme.spacing.lg,
      fontSize: theme.typography.fontSize.base,
      color: theme.colors.text.secondary,
      lineHeight: theme.typography.lineHeight.relaxed,
    },
  };

  return (
    <section style={s.section}>
      <div style={s.inner}>
        <div style={s.header}>
          <span style={s.eyebrow}>{t('public.faq.eyebrow', 'Frequently asked questions')}</span>
          <h2 style={s.h2}>{t('public.faq.heading', 'Got questions?')}</h2>
        </div>
        {faqs.map((key, i) => (
          <div key={key} style={s.item}>
            <button style={s.question(open === i)} onClick={() => toggle(i)}>
              {t(`public.faq.${key}.q`, `Question ${i + 1}`)}
              <ChevronDown size={20} style={s.chevron(open === i)} />
            </button>
            <div style={s.answer(open === i)}>
              <div style={s.answerInner}>{t(`public.faq.${key}.a`, '')}</div>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default FAQSection;
